export const PAYMENT_METHOD_OPTIONS: { label: string; value: string }[] = [
  { label: "Cash", value: "cash" },
  { label: "Card", value: "card" },
  { label: "Bank Transfer", value: "bank_transfer" },
  { label: "QR", value: "qr" },
  { label: "Credit", value: "credit" },
];
